import Vue from "vue";
import Router from "vue-router";
import AuthLayout from "@/layouts/Auth";
import MainLayout from "@/layouts/Main";
import store from "@/store";

import Error404 from "./views/auth/404";
import Error500 from "./views/auth/500";

// import Login from "@/login"; // login from form
import Login from "@/components/system/Auth/Login";
import LoginCallback from "./views/auth/login/callback.vue";
import Lockscreen from "./views/auth/lockscreen";

Vue.use(Router);

const router = new Router({
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // for export
    {
      path: "/employee/export",
      component: () => import("@/views/configAdmin/employee/export-table"),
    },
    {
      path: "/user/export",
      component: () => import("@/views/configAdmin/user/export-table"),
    },

    //auth module

    // notifications
    {
      path: "/notifications",
      redirect: "notifications",
      component: MainLayout,
      name: "notifications",
      children: [
        {
          path: "/notifications",
          component: () =>
            import("@/components/layout/Topbar/Actions/NotificationTabs"),
        },
      ],
    },

    // modules
    {
      path: "",
      redirect: "/config/app",
      component: MainLayout,
      meta: {
        authRequired: true,
        hidden: true,
      },
      children: [
        {
          path: "/auth/login",
          name: "signIn",
          meta: {
            title: "Sign In",
          },
          component: Login,
        },
        {
          path: "/my-info",
          name: "myInfo",
          meta: {
            title: "myInfo",
          },
          component: () => import("@/views/infoMyUser"),
        },

        {
          path: "/config/",
          redirect: "cau-hinh-admin",
          component: () => import("@/layouts/configAdmin/index.vue"),
          meta: {
            authRequired: true,
            hidden: true,
          },
          children: [
            {
              path: "myUser",
              name: "myUser",
              component: () => import("@/views/configAdmin/myUser"),
              meta: {
                appName: "myUser",
              },
            },
            {
              path: "app",
              name: "app",
              component: () => import("@/views/configAdmin/app"),
              meta: {
                appName: "app",
              },
            },
            {
              path: "workLeave",
              name: "workLeave",
              component: () => import("@/views/configAdmin/workLeave"),
              app: "workLeave",
              meta: {
                appName: "workLeave",
              },
            },
            {
              path: "list-permission",
              name: "list-permission",
              component: () => import("@/views/configAdmin/list-permission"),
              app: "list-permission",
              meta: {
                appName: "list-permission",
              },
            },
            {
              path: "user",
              name: "user",
              component: () => import("@/views/configAdmin/user"),
              app: "user",
              meta: {
                appName: "user",
              },
            },

            {
              path: "user/:idUser/",
              name: "viewUpdateDetailUser",
              redirect: "basic-info-user",
              meta: {
                appName: "user",
              },
              component: () =>
                import("@/views/configAdmin/user/viewUpdateDetailUser"),
              children: [
                {
                  path: "basic-info-user",
                  name: "basicInfoUser",
                  component: () =>
                    import(
                      "@/views/configAdmin/user/components/detailUser.vue"
                    ),
                  meta: {
                    appName: "user",
                  },
                },
              ],
            },

            {
              path: "employee",
              name: "employee",
              component: () => import("@/views/configAdmin/employee"),
              app: "employee",
              meta: {
                appName: "employee",
              },
            },

            {
              path: "employee/:idEmployee/",
              name: "viewUpdateDetailEmployee",
              redirect: "basic-info",
              meta: {
                appName: "employee",
              },
              component: () =>
                import("@/views/configAdmin/employee/viewUpdateDetailEmployee"),
              children: [
                {
                  path: "basic-info",
                  name: "basicInfoEmployee",
                  component: () =>
                    import(
                      "@/views/configAdmin/employee/components/detailEmployee.vue"
                    ),
                  meta: {
                    appName: "employee",
                  },
                },
                {
                  path: "employee-leave",
                  name: "workLeaveEmployee",
                  component: () =>
                    import(
                      "@/views/configAdmin/employee/components/workLeaveEmployee"
                    ),
                  meta: {
                    appName: "employee",
                  },
                },
                {
                  name: "Xem nghỉ phép",
                  path: "nghi-phep/:idWorkLeave/view",
                  component: () =>
                    import(
                      "@/views/configAdmin/employee/components/workLeaveEmployee/viewWorkLeaveEmployee"
                    ),
                  meta: {
                    appName: "employee",
                  },
                },
              ],
            },
            {
              path: "department",
              name: "department",
              component: () => import("@/views/configAdmin/department"),
              meta: {
                appName: "department",
              },
            },
            {
              path: "position",
              name: "position",
              component: () => import("@/views/configAdmin/position"),
              meta: {
                appName: "position",
              },
            },
            {
              path: "documentType",
              name: "documentType",
              component: () => import("@/views/configAdmin/documentType"),
              meta: {
                appName: "documentType",
              },
            },
            {
              path: "documentAgencyIssued",
              name: "documentAgencyIssued",
              component: () =>
                import("@/views/configAdmin/documentAgencyIssued"),
              meta: {
                appName: "documentAgencyIssued",
              },
            },
            {
              path: "workShift",
              name: "workShift",
              component: () => import("@/views/configAdmin/workShift"),
              meta: {
                appName: "workShift",
              },
            },
            {
              path: "vehicleType",
              name: "vehicleType",
              component: () => import("@/views/configAdmin/vehicleType"),
              meta: {
                appName: "vehicleType",
              },
            },
            {
              path: "appInPlatformGroup",
              name: "appInPlatformGroup",
              component: () => import("@/views/configAdmin/appInPlatformGroup"),
              meta: {
                appName: "appInPlatformGroup",
              },
            },
            {
              path: "departmentGroup",
              name: "departmentGroup",
              component: () => import("@/views/configAdmin/departmentGroup"),
              meta: {
                appName: "departmentGroup",
              },
            },
            {
              path: "configQLNS",
              name: "configQLNS",
              component: () => import("@/views/configAdmin/userApprovalQLNS"),
              meta: {
                appName: "configQLNS",
              },
            },
            {
              path: "helpdesk",
              name: "helpdesk",
              redirect: "helpdesk/helpdesk-category",
              component: () => import("@/views/configAdmin/helpdeskView"),
              meta: {
                appName: "helpdesk",
              },
              children: [
                {
                  path: "helpdesk-category",
                  name: "helpdeskCategory",
                  component: () => import("@/views/configAdmin/helpdesk"),
                  meta: {
                    appName: "helpdesk",
                  },
                },
                {
                  path: "helpdesk-group",
                  name: "helpdeskGroup",
                  component: () => import("@/views/configAdmin/helpdeskGroup"),
                  meta: {
                    appName: "helpdesk",
                  },
                },
              ],
            },

            {
              path: "documentConfig",
              name: "documentConfig",
              component: () => import("@/views/configAdmin/documentConfig"),
              meta: {
                appName: "documentConfig",
              },
            },
            {
              path: "customer",
              name: "customer",
              component: () => import("@/views/configAdmin/customer"),
              meta: {
                appName: "customer",
              },
            },
            {
              path: "holiday",
              name: "holiday",
              component: () => import("@/views/configAdmin/holiday"),
              meta: {
                appName: "holiday",
              },
            },

            {
              path: "role",
              name: "role",
              component: () => import("@/views/configAdmin/role"),
              meta: {
                appName: "role",
              },
            },

            {
              path: "permissionAction",
              name: "permissionAction",
              component: () => import("@/views/configAdmin/permissionAction"),
              meta: {
                appName: "permissionAction",
              },
            },

            {
              path: "permissionPossession",
              name: "permissionPossession",
              component: () =>
                import("@/views/configAdmin/permissionPossession"),
              meta: {
                appName: "permissionPossession",
              },
            },

            {
              path: "module",
              name: "module",
              component: () => import("@/views/configAdmin/module"),
              meta: {
                appName: "module",
              },
            },

            {
              path: "branchLocation",
              name: "branchLocation",
              component: () => import("@/views/configAdmin/branchLocation"),
              meta: {
                appName: "branchLocation",
              },
            },

            {
              path: "parcelType",
              name: "parcelType",
              component: () => import("@/views/configAdmin/parcelType"),
              meta: {
                appName: "parcelType",
              },
            },
            {
              path: "vehicle",
              name: "vehicle",
              component: () => import("@/views/configAdmin/vehicle"),
              meta: {
                appName: "vehicle",
              },
            },
            {
              path: "reminder",
              name: "reminder",
              component: () => import("@/views/configAdmin/reminder"),
              meta: {
                appName: "reminder",
              },
            },

            //  test thôi
            {
              path: "bs",
              name: "bs",
              component: () => import("@/views/configAdmin/bussinessTrip"),
            },
          ],
        },
      ],
    },

    // System Pages
    {
      path: "/cau-hinh/auth",
      component: AuthLayout,
      redirect: "/cau-hinh/auth/login",
      children: [
        {
          path: "/cau-hinh/error/404",
          meta: {
            title: "Error 404",
          },
          component: Error404,
        },
        {
          path: "/cau-hinh/error/500",
          meta: {
            title: "Error 500",
          },
          component: Error500,
        },
        {
          path: "/cau-hinh/auth/login",
          meta: {
            title: "Sign In",
          },
          component: Login,
        },
        {
          path: "/cau-hinh/auth/login/callback",
          meta: {
            title: "Sign In",
          },
          component: LoginCallback,
        },
        {
          path: "/cau-hinh/auth/lockscreen",
          meta: {
            title: "Lockscreen",
          },
          component: Lockscreen,
        },
      ],
    },

    // Redirect to 404
    {
      path: "/cau-hinh/*",
      redirect: "error/404",
      hidden: true,
    },
  ],
});

router.beforeEach((to, from, next) => {
  // const currentUser = localStorage.getItem("currentUser");
  const AUTH_TOKEN = process.env.VUE_APP_AUTH_TOKEN_NAME || "apollo-token";
  const ictToken = localStorage.getItem(AUTH_TOKEN);
  if (to.name !== "signIn" && !ictToken) {
    next({ name: "signIn" });
  } else {
    next();
  }
});

export default router;
